import { getHttpClient } from '../../../../shared/utils/http-client.ts/index';
import { DocumentChapterGroup } from '../models/document-chapter-group';
import { updateDocumentChapterEndpoint } from './const';

export const updateDocumentChapter = (documentChapter: DocumentChapterGroup) => {
    return getHttpClient().post({ url: updateDocumentChapterEndpoint, data: JSON.stringify(documentChapter) });
};
